import { useQuery } from 'react-query';

const API_URL = 'https://openlibrary.org';

async function fetchChanges() {
    const response = await fetch(`${API_URL}/recentchanges.json`);
    const data = await response.json();
    return data || [];
}

export function useFetchChanges() {
    const { data, isLoading } = useQuery('changes', fetchChanges);
    return { changes: data, isLoading };
}

async function quickSearch(query) {
    const response = await fetch(`${API_URL}/search.json?q=${query}`);
    const data = await response.json();
    return data.docs || [];
}

export function useQuickSearch(query) {
    const { data, isLoading } = useQuery(['quickSearch', query], () => quickSearch(query));
    return { results: data, isLoading };
}

async function advancedSearch(query, author, date, page) {
    let url = `${API_URL}/search.json?q=${query}`;

    if (author) {
        url += `&author=${author}`;
    }

    if (date) {
        url += `&first_publish_year=${date}`;
    }

    const response = await fetch(url);
    const data = await response.json();
    return data.docs || [];
}

export function useAdvancedSearch(query, author, date, page) {
    const { data, isLoading } = useQuery(['advancedSearch', query, author, date, page], () => advancedSearch(query, author, date, page));
    return { results: data, isLoading };
}

async function fetchBookDetails(id) {
    const response = await fetch(`${API_URL}/api/books?bibkeys=OLID:${id}&format=json&jscmd=data`);
    const data = await response.json();
    return data[`OLID:${id}`];
}

export function useFetchBookDetails(id) {
    const { data, isLoading } = useQuery(['bookDetails', id], () => fetchBookDetails(id));
    return { book: data, isLoading };
}

async function fetchWikipediaDetails(title) {
    const response = await fetch(`https://en.wikipedia.org/api/rest_v1/page/summary/${title}`);
    const data = await response.json();
    return data;
}

export function useFetchWikipediaDetails(title) {
    const { data, isLoading } = useQuery(['wikipediaDetails', title], () => fetchWikipediaDetails(title));
    return { wikiData: data, isLoading };
}